import { domQuerySelector } from 'pf-frontend-common/src/helper/dom/query-selector';
import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';
import { WindowLocationService } from 'pf-frontend-common/src/service/window-location/service';

import { DropdownTemplate } from 'common/module/dropdown/template';
import { DropdownViewStoreFactory } from 'common/module/dropdown/view-store.factory';
import { LoaderViewDynamicFactory } from 'common/module/loader/view-dynamic.factory';
import { PaginationComponent } from 'common/module/pagination/component';
import { PaginationViewStoreFactory } from 'common/module/pagination/view-store.factory';
import { PreactView } from 'common/module/preact/view';
import { PropertyParamStoreFactory } from 'common/module/property/param-store.factory';
import { PropertyQueryParamsAdapter } from 'common/module/property/query-params-adapter';
import { PropertyStoreService } from 'common/service/property-store/service';
import { StatsService } from 'common/service/stats/service';
import { PropertyListTemplate } from 'desktop/module/property/list/template';
import { PropertyListViewStoreFactory } from 'desktop/module/property/list/view-store.factory';

import { PropertyTabView } from './view';

export function PropertyTabViewFactory(): PropertyTabView {
  return new PropertyTabView(
    EventEmitterFactory(),
    new PropertyQueryParamsAdapter(),
    WindowLocationService(),
    new PreactView(PropertyListTemplate, PropertyListViewStoreFactory()),
    new PreactView(PaginationComponent, PaginationViewStoreFactory()),
    new PreactView(DropdownTemplate, DropdownViewStoreFactory()),
    new PreactView(DropdownTemplate, DropdownViewStoreFactory()),
    LoaderViewDynamicFactory(),
    PropertyStoreService(),
    PropertyParamStoreFactory(),
    StatsService(),
    domQuerySelector
  );
}
